/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_CzechInputs */



/**
* | output |
* | --- |
* | "Czech" |
*
* @param {Speechmatics_Target_Language_CzechInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_czech = /** @type {((inputs?: Speechmatics_Target_Language_CzechInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_CzechInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tcheque")
	if (locale === "de") return /** @type {LocalizedString} */ ("tschechisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("ceco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("чешский")
	if (locale === "es") return /** @type {LocalizedString} */ ("checo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("捷克语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チェコ語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चेक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tcheco")
	return /** @type {LocalizedString} */ ("Czech")
});